import { render, staticRenderFns } from "./DesktopRenovationFilter.vue?vue&type=template&id=6fac8fe3&"
import script from "./DesktopRenovationFilter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DesktopRenovationFilter.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports